
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 210 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M190.34.427h-3.414v18.777h3.414v-8.96h16.216v8.96h3.418V.427h-3.418v8.108H190.34V.427zm-12.378.854C175.448.466 172.532 0 169.43 0c-8.015 0-14.51 4.394-14.51 9.814 0 5.423 6.495 9.817 14.51 9.817 3.102 0 6.018-.47 8.532-1.283v-1.977c-2.392.977-5.343 1.554-8.532 1.554-6.012 0-10.883-3.634-10.883-8.11 0-4.478 4.87-8.108 10.883-8.108 3.189 0 6.14.574 8.532 1.55V1.281zm-47.459 12.375l6.063-10.47 6.067 10.47h-12.13zm4.36-13.229l-11.099 18.777h3.524l2.225-3.84h14.107l2.225 3.84h3.526L138.273.427h-3.41zM98.155 2.135h8.964c2.122 0 3.842 1.432 3.842 3.2 0 1.767-1.72 3.2-3.842 3.2h-8.964v-6.4zm11.099 8.107c2.357 0 4.266 1.623 4.266 3.628 0 2.004-1.91 3.627-4.266 3.627H98.156v-7.255h11.099zm3.183-1.389c1.195-.891 1.938-2.138 1.938-3.518 0-2.71-2.867-4.908-6.4-4.908H94.74v18.777h15.366c3.77 0 6.829-2.388 6.829-5.334 0-2.307-1.875-4.272-4.498-5.017zM82.488.427l-8.23 8.962-8.23-8.962h-3.72l10.19 11.094v7.683h3.52v-7.683L86.208.427h-3.72zM53.01 13.657H40.88l6.065-10.471 6.065 10.47zM45.238.426L34.14 19.204h3.525l2.224-3.84H54l2.224 3.84h3.524L48.652.427h-3.414zM3.308 3.584l9.495 9.062 9.496-9.062v15.62h3.307V.427h-3.414L12.803 9.39 3.414.427H0v18.777h3.307V3.584z","fill":"inherit","fill-rule":"evenodd"}})])
          )
        }
      }
    